import VueProgressBar from 'vue-progressbar'

export default {
    install(Vue, options) {

        const optionsDefaults = {
            color: '#c236ac',
            failedColor: 'red',
            thickness: '4px'
        }

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(VueProgressBar, options)

    }
}
